// import { calcTargetItemSize } from './layoutHelper';
import { __assign } from "tslib";
export var createOptions = function (options) {
    try {
        var parsedOptions = options.jsonStyleParams
            ? JSON.parse(options.jsonStyleParams)
            : {};
        return __assign(__assign({}, options), parsedOptions);
    }
    catch (e) {
        return {};
    }
};
//# sourceMappingURL=designedPresetGallery.js.map